import {legacy_createStore as createStore, combineReducers, applyMiddleware} from "redux";
import thunk from 'redux-thunk';
import { routerMiddleware } from 'react-router-redux';
import { createHashHistory } from 'history';

import { reducer } from './reducer';

const hashHistory = createHashHistory();
const middleware: any = routerMiddleware(hashHistory);



/**
 * 全局store
 * @type {Store<any & any, Action> & {dispatch: ThunkDispatch<any, E, Action>}}
 */
export const store = createStore(combineReducers({
    reducer,
}), applyMiddleware(thunk, middleware));

